// import React from "react";
// import { Routes, Route, Link } from "react-router-dom";
// import Home from "./Home";
// import About from "./About";
// import Services from "./Service";
// import Blogs from "./Blogs";
// import Contact from "./Contact";
// import Footer from "./Footer";

// function App() {
//   return (
//     <div className="landing">
//       {/* Navbar */}
//       <nav className="navbar">
//         <div className="logo">Deepbrik Technologies</div>
//         <ul>
//           <li><Link to="/">Home</Link></li>
//           <li><Link to="/about">About Us</Link></li>
//           <li><Link to="/services">Services</Link></li>
//           <li><Link to="/blogs">Blogs</Link></li>
//           <li><Link to="/contact">Contact Us</Link></li>
//         </ul>
//       </nav>

//       {/* Pages */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/blogs" element={<Blogs />} />
//         <Route path="/contact" element={<Contact />} />
//       </Routes>

//       {/* Footer */}
//       <Footer />
//     </div>
//   );
// }

// export default App;


import React, { useState, useEffect } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";

import Home from "./Home";
import About from "./About";
import Service from "./Service";
import Blogs from "./Blogs";
import Contact from "./Contact";
import Footer from "./Footer";



function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu and scroll to top on route change
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="landing">
      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <div className="logo">
            <Link to="/">
              <img src="/Images/fevi12.jpg" alt="Logo" style={{ height: "50px" }} />
            </Link>
          </div>

          {/* Mobile menu toggle */}
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "✖" : "☰"}
          </div>

          {/* Navigation links */}
          <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <li>
              <Link to="/" className={location.pathname === "/" ? "active" : ""}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === "/about" ? "active" : ""}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/services" className={location.pathname === "/service" ? "active" : ""}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/blogs" className={location.pathname === "/blogs" ? "active" : ""}>
                Blogs
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>
                Contact Us
              </Link>
            </li>
            {/* <li>
              <Link to="/footer"className={location.pathname === "/Footer" ? "active" : ""}> Footer</Link>
            </li> */}
          </ul>
        </div>
      </nav>

      {/* Pages */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        
      </Routes>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;

